<template>
  <div class="card bg-secondary border-0 mb-0 shadow-none">
    <div class="card-header bg-transparent pb-5  border-0">
      <div class="logo-center text-center mb-4 pb-4 border-bottom">
        <!-- <img src="img/brand/white.png"> -->
        <img 
          class="icon-logo" 
          src="@/assets/img/brand/logo.svg">
      </div>
    </div>

                       
  </div>
</template>

<script>
export default {
    name: "Another",
    data() {
        return {
           
        }
    }
}
</script>

<style lang="sass">

</style>